<template>
    <base-link v-bind="$attrs" class="link--white" v-on="$listeners">
        <slot></slot>
    </base-link>
</template>
<script>
import BaseLink from '../base/base_link';
export default {
  components: {
    'base-link': BaseLink,
  },
};
</script>
